export const LEGACY_IFRAME_TITLE = 'legacyLS';

export const IFRAME_ROUTE_MESSAGE_EVENT_NAME = {
  LEGACY: 'ang.app.stateChangeSuccess',
  NAVIGATE_TO_URL: 'ang.app.navigate_to_url',
  NAVIGATE: 'ang.app.navigate',
  HOME: 'ang.app.navigate_to_home',
  WIDGET: 'ang.app.open_widget',
  NAVIGATE_BACK: 'ang.app.navigate_back',
  RELOAD: 'ang.app.reload',
  PROGRAMS_NAVIGATE: 'ang.app.open_all_programs',
  PROGRAM_NAVIGATE: 'ang.app.open_program',
};

export const PATH_NAMES = {
  BASE: '',
  DASHBOARD: 'home',
  WIDGET: 'widget',
  HOME: 'ui',
  LEGACY: 'legacy',
  NOTIFICATIONS: 'notifications',
  PROGRAMS: 'programs',
  PROGRAM: ':programId',
  INTEGRATIONS: 'integrations',
  BOOSTUP: 'boostup',
};
